import { FC, useContext, useEffect, useLayoutEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link } from "react-router-dom";

import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";

import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";
import { forgotpasswordSchema } from "../../validation/forgotPassword";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { ForgotPasswordResponseType } from "./types";
import { LoaderContext } from "../../context/loaderContext";
// import ContactAndSafetyInfo from "../../components/contactAndSafetyInfo";
// import {TextAlignProps} from "../../components/contactAndSafetyInfo/types";






const HubForgotPassword: FC = (): JSX.Element => {
  const { control, handleSubmit, reset } = useForm({
    mode: 'all',
    resolver: yupResolver(forgotpasswordSchema),
  });
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);





  const { loading, error, data, mutate, removeErrorAndData } = useFetch<null, null, ForgotPasswordResponseType>(APIEndpoints.USER_FORGOT_PASSWORD);

  // useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (data || error) {
      hideLoader();
      if (data) {
        const { message } = data;
        showToast([message], ToastTypes.SUCCESS);
        reset();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const submitForm = async (values: { email: string }) => {
    setLoader();
    if ((error && error.length > 0) || data) removeErrorAndData();

    mutate({ user: values });
  };




  return (
      <div className="container-fluid login-sec pt-3 pt-lg-5 p-0 overflow-auto d-flex flex-column flex-fill">
        <div className="container flex-fill d-flex flex-column">
          <div className="row flex-fill">
              <div className="col-xl-8 col-lg-7 col-md-5 col-12 d-lg-block d-md-block d-none"></div>
            <div className="col-xl-4 col-lg-5 col-md-7 col-12">
              <form className="login-box bg-white rounded-3 p-4 shadow-lg" onSubmit={handleSubmit(submitForm)}>
                <h5 className="mb-0 fw-bold text-primary">Forgot your password?</h5>
                <div className="mt-4">
                  <Controller
                      name="email"
                      control={control}
                      defaultValue=""
                      render={({field, fieldState: {error}}) => (
                          <HubInputField
                              inputId="email"
                              isRowBased={false}
                              isRequired={true}
                              field={field}
                              error={error}
                              inputLabel="Email"
                              inputType="email"
                          />
                      )}
                  />
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <button disabled={loading} className="btn btn-primary" type="submit">
                      {loading ? (<i className="spinner-border me-2"></i>) : null}
                      Send me reset password instructions
                    </button>
                    <p className="mb-0 mt-2">
                      <Link to="/users/sign_in">Log in</Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <FooterText footerType="black"/>
        </div>
      </div>
  );
};
export default HubForgotPassword;
